import { useTranslation } from "react-i18next";
import CheckIcon from "../../../icons/checkIcon";

const DangerousGoods = () => {
  const { t } = useTranslation();
  return (
    <main className="py-20 ">
      <div className="w-11/12 mx-auto space-y-10">
        <section>
          <h1 className=" font-semibold text-[32px] text-center pb-10 ">
            {t("transportOfDangerousGoods")}
          </h1>
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("ensuringSafetyCompliance")}
          </h2>
          <p className=" text-[18px]">{t("criticalAspects")}</p>
        </section>
        <section className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/dangerousGoods1.jpg"
            alt="dangerous goods 1"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/dangerousGoods2.jpg"
            alt="dangerous goods 2"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/dangerousGoods3.jpg"
            alt="dangerous goods 3"
          />
          <img
            className="size-full lg:size-[280px] rounded-2xl object-cover shadow-mainShadow
"
            src="/assets/dangerousGoods4.jpg"
            alt="dangerous goods 4"
          />
        </section>
        <section className="bg-white shadow-md rounded-2xl p-9">
          <h2 className="text-mainRed text-[20px] font-bold my-4">
            {t("transportingHazardousGoods")}
          </h2>
          <p>{t("transportingHazardousGoodsOneOFTheMost")}</p>
          {/* company introduction section */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("trustedExpertise")}
          </h3>
          <p>{t("deepExpertiseInShipping")}</p>
          {/* what are hazardous goods section */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("whatAreHazardousGoods?")}
          </h3>
          <p>{t("hazardousGoodsAreMaterials")}</p>
          <div>
            <p>
              <span className="text-mainBlue">{t("explosives-")}</span>
              {t("dynamiteAndFireworks")}
            </p>
            <p>
              <span className="text-mainBlue">{t("gases-")}</span>
              {t("propaneAndAmmonia")}
            </p>
            <p>
              <span className="text-mainBlue">{t("flammableLiquids-")}</span>
              {t("gasolineAndAlcohol")}
            </p>
            <p>
              <span className="text-mainBlue">{t("flammableSolids-")}</span>
              {t("sulfurAndPhosphorus")}
            </p>
            <p>
              <span className="text-mainBlue">{t("oxidizing-")}</span>
              {t("hydrogenPeroxide")}
            </p>
            <p>
              <span className="text-mainBlue">{t("toxicSubstances-")} </span>
              {t("arsenicAndProducts")}
            </p>
            <p>
              <span className="text-mainBlue">{t("radioactiveMaterials-")}</span>
              {t("uraniumAndNuclear")}
            </p>
            <p>
              <span className="text-mainBlue">{t("corrosiveSubstances-")}</span>
              {t("likeStrongAcids")}
            </p>
            <p>
              <span className="text-mainBlue">
                {t("miscellaneousHazardousMaterials-")}
              </span>
              {t("otherDangerousSubstances")}
            </p>
          </div>
          {/* how does section */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("howDoesMegtlogistics")}
          </h3>
          <div className="space-y-2">
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("complianceWithSafetyStandards")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("useOfSpecializedContainers")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("advancedTrackingSolutions")}</span>
            </p>
          </div>
          {/* importance of hazardous goods transport */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("importanceOfHazardousGood")}
          </h3>
          <p>
            <span className="text-mainBlue">1.</span>
            {t("supportingVitalIndustries")}
          </p>
          <p>
            <span className="text-mainBlue">2.</span>
            {t("ensuringGlobalSupply")}
          </p>
          <p>
            <span className="text-mainBlue">3.</span>
            {t("enhancingPublicSafety")}
          </p>
          {/* challenges in transporting hazardous goods */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("challengesWithHazardousGoods")}
          </h3>
          <p>
            <span className="text-mainBlue">1.</span>
            {t("strictSafetyStandards")}
          </p>
          <p>
            <span className="text-mainBlue">2.</span>
            {t("environmentalRisk")}
          </p>
          <p>
            <span className="text-mainBlue">3.</span>
            {t("hightCostTransporting")}
          </p>
          {/* how does section */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("safeAndEfficientSolutions")}
          </h3>
          <div className="space-y-4">
            <section>
              <p>
                <span className="text-mainBlue">1.</span>
                {t("utilizingLatestTrackingTechno")}
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("GpsTrackingSystems")}</span>
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("smartSensors")}</span>
              </p>
            </section>
            <section>
              <p>
                <span className="text-mainBlue">2.</span>
                {t("continuousEmployeeTraining")}
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("specializedTrainingPrograms")}</span>
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("regularDrills")}</span>
              </p>
            </section>
            <section>
              <p>
                <span className="text-mainBlue">3.</span>
                {t("specializedEquipment")}
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("insulatedContainers")} </span>
              </p>
              <p className="flex gap-2 my-2 item-center">
                <span>
                  <CheckIcon />
                </span>
                <span>{t("equippedWithCooling")}</span>
              </p>
            </section>
          </div>
          {/* why choose section */}
          <h3 className="text-[20px] text-mainRed font-bold my-4">
            {t("WhyMegtlogisticsForHazardousGoods?")}
          </h3>
          <div className="space-y-4 text-lg">
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("extensiveExperience")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("advancedSecurity")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("strongGlobalPartnerships")}</span>
            </p>
            <p className="flex gap-2 item-center">
              <span>
                <CheckIcon />
              </span>
              <span>{t("flexibleLogistics")}</span>
            </p>
          </div>
        </section>
      </div>
    </main>
  );
};

export default DangerousGoods;
